import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckboxInput } from "common/components/form/CheckboxInput";
import { useMutation } from "react-query";
import { setOrganizationFilesRetention } from "../../api/api";
import { Organization } from "../../types/api.types";
import { showToastError, showToastSuccess } from "common/toast/toast";
import { queryClient } from "../../modules/queryClient";

interface FilesRetentionSettingsProps {
  organization: Organization;
}

export const FilesRetentionSettings: React.FC<FilesRetentionSettingsProps> = ({
  organization,
}) => {
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation(setOrganizationFilesRetention, {
    onSuccess: (data) => {
      queryClient.setQueryData<Organization | undefined>("organization", data);
      queryClient.invalidateQueries("organization");
      showToastSuccess(t("filesRetention.updateSuccess"));
    },
    onError: () => {
      showToastError(t("filesRetention.updateError"));
    },
  });

  const handleChange = (checked: boolean) => {
    if (isLoading) return;
    mutate(checked);
  };

  return (
    <div>
      <CheckboxInput
        label={t(
          "filesRetention.deleteAfterReportGeneration",
          "Automatically delete files after report generation"
        )}
        isChecked={organization.deleteFilesAfterReportGeneration ?? false}
        onChange={handleChange}
        style={{ marginTop: 12 }}
      />
    </div>
  );
};
